import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Navigate, Routes } from 'react-router';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import { adminRoutes } from 'app/admin/routes/routes';
import { analysisProtocolCorrectionRoutes } from 'app/analysis-protocol-correction/routes/routes';
import { animalBrowserRoutes } from 'app/animal-browser/routes/routes';
import { errorRoutes } from 'app/error/routes/routes';
import { legacyRoutes } from 'app/legacy/routes';
import { matingRoutes } from 'app/mating/routes/routes';
import { milkabilityRoutes } from 'app/milkability/routes/routes';
import { simpleUserSelector } from 'app/user';
import { userRoutes } from 'app/user/routes/routes';
import { appRoutePaths } from './route-paths';
const addEndListener = (node: HTMLElement, done: () => void): void => node.addEventListener('transitionend', done, false);

/**
 * Defines the top-level route order and keeps route transitions aligned with the shell state.
 *
 * @returns The full application route switch.
 *
 * @example
 * <AppRoutes />
 */
export const AppRoutes: React.FC = () => {
  const pathName = useSelector(simpleUserSelector.currentPathname);
  return <SwitchTransition data-sentry-element="SwitchTransition" data-sentry-component="AppRoutes" data-sentry-source-file="routes.tsx">
            <CSSTransition key={pathName} addEndListener={addEndListener} classNames="fade" unmountOnExit mountOnEnter in data-sentry-element="CSSTransition" data-sentry-source-file="routes.tsx">
                <Routes location={pathName} data-sentry-element="Routes" data-sentry-source-file="routes.tsx">
                    <Route path="/" element={<Navigate to={appRoutePaths.home} replace />} data-sentry-element="Route" data-sentry-source-file="routes.tsx" />
                    {userRoutes}
                    {adminRoutes}
                    {legacyRoutes}
                    {matingRoutes}
                    {animalBrowserRoutes}
                    {milkabilityRoutes}
                    {analysisProtocolCorrectionRoutes}
                    {errorRoutes}
                    <Route path="*" element={<Navigate to="/" replace />} data-sentry-element="Route" data-sentry-source-file="routes.tsx" />
                </Routes>
            </CSSTransition>
        </SwitchTransition>;
};